import { Component, OnInit, ViewChild, Input, AfterViewInit, OnDestroy, ChangeDetectionStrategy, ElementRef } from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Observable } from 'rxjs';

//import { ResizeObserver } from '@juggle/resize-observer';

//import { ScreenService } from '@app/data';
import { PlayerService } from './player.service';



//type PlayerSwitch = 'youtube' | 'vimeo';


@Component({
  selector: 'app-player',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.less']
})
export class PlayerComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() medium: any;
  @Input() playerName?: string = 'main';
  /*@Input() dimensions: any;*/

  //private providerService = {youtube: this.ytService, vimeo: this.vimeoService};

  //private playerSwitch!: PlayerSwitch;

  //private observer: any;

  //private dimensions: any = {};

  constructor(
    //private _sanitizer: DomSanitizer,
    private playerService: PlayerService,

    //private ytService: YTService,
    //private vimeoService: VimeoService,

    private host: ElementRef
  ) { 
    //console.log('PlayerComponent ngOnInit this.medium ', this.medium);
  }

  ngOnInit(): void {

    console.log('PlayerComponent ngOnInit this ', this);
    //console.log('PlayerComponent ngOnInit this.medium ', this.medium);
  	//console.log('PlayerComponent ngOnInit this.player ', this.player);

    /*const element = this.host.nativeElement;

    this.dimensions = {
      width: element.clientWidth,
      height: element.clientHeight
    };*/

    /*this.screenService.setPlayerDimensions({
      width: element.clientWidth,
      height: element.clientHeight
    });*/


    /*this.observer = new ResizeObserver(entries => { 
      console.log('PlayerComponent ResizeObserver entries[0] ', entries[0]);

      this.screenService.setPlayerDimensions(entries[0].contentRect);
    });

    this.observer.observe(this.host.nativeElement);*/
  }

  ngAfterViewInit(): void {
    //console.log('PlayerComponent ngOnInit this ', this);
    //console.log('PlayerComponent ngAfterViewInit this.medium ', this.medium);

    const element = this.host.nativeElement;

    const medium = {
      ... this.medium,
      dimensions: {
        width: element.clientWidth,
        height: element.clientHeight
      },
      playerName: this.playerName
    }

    this.playerService.loadScript(medium);

    //this.playerSwitch = this.medium.provider;

    //this.providerService[this.playerSwitch].loadVideo(medium);
  }

  ngOnDestroy(): void {
    //console.log('PlayerComponent ngOnDestroy');

    //this.observer.unobserve(this.host.nativeElement);

    
  }

}
